import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import Header from '../../../shared/components/Header'
import View from '../View'

// Styles
import './index.scss'

// Utils
import { translation } from '../../../utils/helpers'

class SingleCustomer extends Component {

  constructor (props) {
    super(props)
    this.state = {
      customer: {
        CustomerId: null
      }
    }
    this.onSave = this.onSave.bind(this)
  }

  componentDidMount () {
    this.setState({
      customer: {
        CustomerId: this.props.params.customerID
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.params.customerID !== this.props.params.customerID) {
      this.setState({
        customer: {
          CustomerId: nextProps.params.customerID
        }
      })
    }
  }

  onSave () {
    // Toastr
    // window.toastr.success(translation('13464'), translation('13424'))
  }

  getCustomers () {
  }

  render () {
    let isCustomer = this.props.auth.user.UserType === 4

    return (
      <div className='single_customer__screen'>
        <Header router={this.props.router} title={isCustomer ? translation('700') : translation('6')} icon={'menu/Settings-White.png'} />
        <div className='single_customer__screen--inner'>
          {this.state.customer.CustomerId !== null && <View ref='view' isCustomer item={this.state.customer} onSave={this.onSave} getCustomers={this.getCustomers} />}
        </div>
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(SingleCustomer)



// WEBPACK FOOTER //
// ./src/app/pages/Customers/Single/index.js